<template>
  <div class="auto-gam-resolution-modal">
    <Modal
      :active="true"
      :primary-button-disabled="
        disableActionButton || caseDetails?.disputeStage === 'Close'
      "
      :primary-button-label="
        actionButtonText == 'No GAM - Manual exisiting process need to followed'
          ? ''
          : actionButtonText
      "
      size="medium"
      :close-on-click-outside="false"
      @onClose="onClose()"
      @onConfirm="onCreateGam()">
      <template #header>
        <p>Auto Gam Resolution Details</p>
      </template>
      <template #content>
        <div>
          <div v-if="gamResolutionValues.length">
            <AutoGamResolutionTable
              :auto-gam-resolution-columns="autoGamResolutionColumns"
              :auto-gam-resolution-values="gamResolutionValues"
              :table-action-columns="tableActionColumns"
              :selected-rows="selectedRows"
              :selected-row-by-ids="selectedRowByIds"
              :active-row="activeRow"
              @updateActiveRow="updateActiveRow"
              @onMultiSelectRow="onMultiSelectRow"
              @getActionButtonText="getActionButtonText" />
          </div>
          <div v-else>Auto gam resolution data is not present</div>
        </div>

        <div v-if="isLoading">
          <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"
            color="#0573ab" />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import {
  autoGamResolutionColumns,
  tableActionColumns,
} from "@/config/disputeDataConstant.js";
import AutoGamResolutionTable from "@/components/AutoGamResolution/AutoGamResolutionTable.vue";

// Actions
import { disputeActions } from "@/actions";
import { gamActions } from "@/actions";
// Util
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { getMsalIdToken } from "@/utils/helpers";
import Loading from "vue-loading-overlay";
import { showToast } from "@/components/common/Toast";
import { REDIRECT_GAM_URI } from "@/config/constant.js";

export default {
  name: "AutoGamResolutionModal",
  components: {
    AutoGamResolutionTable,
    Loading,
  },
  props: {
    caseDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      autoGamResolutionColumns,
      gamResolutionValues: [],
      tableActionColumns,
      selectedRowByIds: [],
      selectedRows: [],
      activeRow: {},
      isLoading: false,
      actionButtonText: "",
      disableActionButton: false,
    };
  },
  computed: {
    buttonDisableCheck() {
      return this.selectedRows.filter((item) => item?.isPotentialAccept);
    },
  },
  mounted() {
    this.fetchAutoResolutionInfo();
  },
  methods: {
    updateActiveRow(row) {
      this.activeRow = row;
    },
    async fetchGamInfoForInvoiceNumber() {
      try {
        let { data } = await AxiosFetchForMsal(
          gamActions.getGamInfoForInvoiceNumber(
            this.caseDetails?.invoiceNumber,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.disableActionButton = data?.count ? true : false;
      } catch (error) {}
    },

    async updateDispute(payload) {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateDisputeFromSfdc(
            payload,
            this.caseDetails?.ohpDisputeId,
            await getMsalIdToken(this)
          )
        );
        showToast("success", `User preference successfully saved.`);
      } catch (error) {
        showToast(
          "error",
          err?.response?.data?.errorMessage || "Unable to save User preference"
        );
      }
    },

    onMultiSelectRow(selectedItems) {
      this.selectedRows = [...selectedItems];
      if (this.selectedRows?.length) {
        this.selectedRowByIds = this.selectedRows.map(
          (item) => item.charge_type
        );
      } else {
        this.selectedRowByIds = [];
      }
    },
    async onCreateGam() {
      if (this.actionButtonText == "Create Manual GAM") {
        const {
          idTokenClaims: { EmployeeID: employeeId, name: userName },
        } = this.$store.getters.getTokenData;
        await Promise.allSettled([
          this.updateDispute({
            disputeStage: "In-Process",
            statusCode: "20",
            statusDescription: "In Process",
            processorName: `${employeeId}`,
            noteDescription: "Triggered partial GAM creation flow.",
            isAutoGamResolutionModal: false,
          }).then(async () => {
            this.$emit("onModalClose");
            const formGamRequestInfo = {
              invoiceNumber: this.caseDetails?.invoiceNumber,
              chargesInfo: this.gamResolutionValues
                ?.map((item) => {
                  return {
                    ...item,
                    expectedAmount: item?.expectedAmount.replaceAll("$", ""),
                  };
                })
                ?.filter((item) => {
                  return (
                    (item?.expectedQuantity >= 0 &&
                      item?.expectedAmount >= 0 &&
                      item?.outcome == "accept") ||
                    item?.isPotentialAccept
                  );
                }),
              gamType: "AB36",
              searchType: "I",
              type: "single",
              areaCode: this.caseDetails?.areaCode,
              areaName: this.caseDetails?.areaName,
              companyCode: this.caseDetails?.companyCode,
              businessAreaCode: this.caseDetails?.businessAreaCode,
              countryCode: this.caseDetails?.countryCode,
              countryName: this.caseDetails?.countryName,
              businessAreaDescription:
                this.caseDetails?.businessAreaDescription,
            };
            try {
              const { data } = await AxiosFetchForMsal(
                disputeActions.saveGamRequestDetails(
                  {
                    ohpDisputeId: this.caseDetails?.ohpDisputeId,
                    ohpGamRequest: JSON.stringify(formGamRequestInfo),
                  },
                  await getMsalIdToken(this)
                )
              );
              window
                .open(
                  `${REDIRECT_GAM_URI}gam-ticket-create?ohpDisputeId=${this.caseDetails?.ohpDisputeId}`,
                  "_blank"
                )
                .postMessage(
                  JSON.stringify(formGamRequestInfo),
                  `${REDIRECT_GAM_URI}gam-ticket-create?ohpDisputeId=${this.caseDetails?.ohpDisputeId}`
                );
              localStorage.setItem(
                "gamRequestDetails",
                JSON.stringify(formGamRequestInfo)
              );
            } catch (error) {}
          }),
        ]);
      } else {
        try {
          this.isLoading = true;
          const algoProcessAutomationDetails =
            this.gamResolutionValues
              ?.filter((item) => item?.isPotentialAccept)
              ?.map((item) => {
                return {
                  chargeCode: item?.charge_type,
                  currentAmount: item?.currentAmount,
                  expectedAmount: item?.expectedAmount,
                  algoEvaluationComments: [],
                };
              }) || [];
          let createGamRequest = {
            event_type: "OHP_DV_CREATE_GAM",
            tenant: "DISPUTE",
            correlation: this.caseDetails?.ohpDisputeId,
            business_key: this.caseDetails?.ohpDisputeId,
            source_system: this.caseDetails?.createdSource,
            event_body: [
              {
                invoiceNumber: this.caseDetails?.invoiceNumber,
                ohpDisputeId: this.caseDetails?.ohpDisputeId,
                disputeSourceSystem: this.caseDetails?.createdSource,
                algoProcessAutomationDetails: algoProcessAutomationDetails,
              },
            ],
          };
          const { data } = await AxiosFetchForMsal(
            gamActions.initiateAutoGamCreateFlow(
              createGamRequest,
              `Bearer ${await getMsalIdToken(this)}`
            )
          );
          this.isLoading = false;
          this.onClose();
          showToast("success", "Initiated Auto Create Gam successfully!");
        } catch (err) {
          showToast(
            "error",
            "Failed to initiate Auto Gam creation, Please try again."
          );
          this.isLoading = false;
        }
      }
    },
    onClose() {
      this.updateDispute({
        isAutoGamResolutionModal: false,
      });
      this.$emit("onModalClose");
    },
    async fetchAutoResolutionInfo() {
      try {
        this.isLoading = true;
        let { data } = await AxiosFetchForMsal(
          disputeActions.getAutoResolutionDetails(
            this.caseDetails.invoiceNumber,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );

        let autoAllocationList = [];
        data?.forEach((element) => {
          if (element?.payload?.Details?.[0]?.charge_type) {
            const details = element.payload.Details.map((item) => {
              return {
                ...item,
                algo_type: element.payload?.algo_type,
                decision: "Potential Accept",
                isPotentialAccept: true,
              };
            });
            autoAllocationList = [...autoAllocationList, ...details];
          } else {
            const chargeType = element?.category?.split("-")?.[0]?.trim();
            const decision = element?.category?.split("-")?.[1]?.trim();
            autoAllocationList.push({
              algo_type: element.payload?.algo_type,
              decision,
              charge_type: chargeType,
              isPotentialAccept: element?.payload?.isPotentialAccept,
              expectedAmount: element?.payload?.expectedAmount
                ? `$ ${element?.payload?.expectedAmount}`
                : `$ 0`,
              expectedQuantity: element?.payload?.expectedQuantity,
              invoiceBaseRate: element?.payload?.invoiceBaseRate,
              invoiceQuantity: element?.payload?.invoiceQuantity,
            });
          }
        });

        this.gamResolutionValues = autoAllocationList;

        this.selectedRowByIds = [
          ...this.selectedRowByIds,
          ...this.gamResolutionValues
            ?.filter((item) => {
              return item?.isPotentialAccept;
            })
            ?.map((item) => item?.charge_type),
        ];

        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        this.gamResolutionValues = [];
      }
    },
    getActionButtonText(
      actionButtonText,
      disableActionButton,
      gamResolutionValues
    ) {
      this.actionButtonText = actionButtonText;
      this.disableActionButton = disableActionButton;
      this.gamResolutionValues = gamResolutionValues;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.auto-gam-resolution-modal {
  .modal--medium {
    width: 1011px !important;
    height: fit-content !important;
    .modal__content {
      padding: 0 24px 24px;
      max-height: 330px;
      min-height: 130px;
    }
  }
  &__container {
    cursor: pointer;
    position: relative;
    margin-bottom: 16px;
  }
}
</style>
